<template>
  <div class="plan">

    <img src="https://yujin-hm-prod.oss-cn-beijing.aliyuncs.com/common/Plans.png" alt="">
<!--    <div class="upload">-->
<!--      <h2>上传胃肠道准备工作</h2>-->
<!--      <div class="van_up">-->
<!--        <van-uploader v-model="fileList"-->
<!--                      :deletable="true"-->
<!--                      @delete="deletes"-->
<!--                      :max-size="10 * 1024 * 1024"-->
<!--                      @oversize="onOversize"-->
<!--                      :max-count="1"-->
<!--                      :after-read="afterJust" >-->
<!--          <template #default>-->
<!--            <div class="uploader"></div>-->
<!--          </template>-->
<!--        </van-uploader>-->
<!--      </div>-->
<!--    </div>-->

<!--    <ul class="standard" style="margin-bottom: 18px;" >-->
<!--      <h2>胃肠道准备说明</h2>-->
<!--      <li>-->
<!--        <img src="../../../assets/Deta/Plan.png" alt="">-->
<!--      </li>-->
<!--    </ul>-->

<!--    <ul class="standard">-->
<!--      <h2>胃肠道准备说明</h2>-->
<!--      <li>-->
<!--        <p>一、肠镜检查术前准备</p>-->
<!--        1、检查前一天晚餐进食容易消化饮食，如软饭、稀饭、面条、豆腐、鸡蛋、牛奶、豆浆等，禁食含粗纤维类食物。<br>-->
<!--        2、上午检查患者检查当日早上禁食，下午检查患者当天早上可以喝牛奶豆浆，中午禁食，无痛检查前两个小时禁水。<br>-->
<!--        3、按要求口服清洁剂清洗肠道，一般会在服药两小时内排干净，最后排出的大便为清水者或黄水不带粪渣方可检查。<br>-->
<!--      </li>-->
<!--      <li>-->
<!--        <p>二、 胃镜检查术前准备</p>-->
<!--        检查前一天晚上8时后禁食，检查当天早上禁食，禁水，禁服药物（降压药可舌下含服）。-->
<!--      </li>-->
<!--      <li>-->
<!--        <p>三、注意事项</p>-->
<!--        1、检查当天按预约序号在门口排队等候。<br>-->
<!--        2、无痛检查要求至少一名家属陪同，检查完后至少半小时才能离开医院，检查当天禁止开车，禁止高空作业。<br>-->
<!--        3、女性患者行结肠镜检查应避开月经期及妊娠期。<br>-->
<!--      </li>-->
<!--      <li>-->
<!--        <p>四、无痛胃肠镜检查注意事项</p>-->
<!--        1、愿进行无痛胃镜检查者，最好提前预约，以便合理安排。<br>-->
<!--        2、对有心脏疾病者，可能需进行心电图检查，必要时进行心内科治疗。<br>-->
<!--        3、对合并呼吸系统疾病者，可能要做呼吸系统全面检查，必要时进行呼吸内科治疗。<br>-->
<!--      </li>-->
<!--    </ul>-->

    <div style="display: flex; justify-content: center; margin-bottom: 1.25rem" v-if="$route.query.productCategory == 3 && ($route.query.status == 1 || $route.query.status == 2)" >
      <van-button style="width: 60%!important;" @click="link" type="info" block >联系客服</van-button>
    </div>

  </div>
</template>

<script>
import qrCode from "../../../assets/TestKit/qrCode.png";
import { ImagePreview} from "vant";
export default {
  name: "StomachPlan",
  data() {
    return{
      fileList: []
    }
  },
  created() {

    // this.get_url(this.$route.query.id);
  },
  mounted() {

  },
  methods: {
    link() {
      ImagePreview([qrCode])
    },

    // 获取图片
    get_url(y) {
      this.$get("appointment/img",y,true)
        .then(res=> {
          if(res) {
            if(res.data) {
              let arr= [];
              let obj= {};
              obj["url"]= res.data;
              arr.push(obj)
              this.fileList= arr;
            }
          }
        })
    },
    deletes(file) {
      console.log(file)
    },
    // 上传图片
    afterJust(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var formData = new FormData();
      formData.append('file', file.file);
      formData.append('appointmentId', this.$route.query.id);
      this.$post("appointment/img", formData)
        .then(res => {
          console.log(res);
          file.status = 'done';
          this.get_url(this.$route.query.id);
        })

    },
    onOversize() {
      this.$toast.error("最大可上传10M");
    }
  },
  components: {
    [ImagePreview.name]: ImagePreview,
  }
}
</script>

<style lang="less" scoped>
  @import "../../../style/My/Order/StomachPlan";
</style>
